/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Field_Video1Inputs */

const vi_guidevideo_field_video1 = /** @type {(inputs: Guidevideo_Field_Video1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

/**

* @param {Guidevideo_Field_Video1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_field_video1 = /** @type {((inputs?: Guidevideo_Field_Video1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Field_Video1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_field_video1(inputs)
});
export { guidevideo_field_video1 as "guideVideo_field_video" }